export type VisibilityChannelKey = 'vacasa' | 'casago';

/** Mirrors API `visibility_config` (PM channel flags). */
export type ApiVisibilityConfig =
    | {
          vacasa?: boolean;
          casago?: boolean;
      }
    | null
    | undefined;

export interface ParsedVisibilityTag {
    key: VisibilityChannelKey;
    channelLabel: string;
    value: boolean;
}

const ORDER: VisibilityChannelKey[] = ['vacasa', 'casago'];

const LABELS: Record<VisibilityChannelKey, string> = {
    vacasa: 'Vacasa',
    casago: 'Casago',
};

/**
 * Returns one entry per channel explicitly set on the config object (booleans only).
 * Omits null, non-objects, and keys not present.
 */
export function parseVisibilityConfigTags(config: ApiVisibilityConfig): ParsedVisibilityTag[] {
    if (config === null || config === undefined) {
        return [];
    }
    if (typeof config !== 'object' || Array.isArray(config)) {
        return [];
    }

    const result: ParsedVisibilityTag[] = [];
    for (const key of ORDER) {
        if (!Object.prototype.hasOwnProperty.call(config, key)) {
            continue;
        }
        const raw = (config as Record<string, unknown>)[key];
        if (typeof raw !== 'boolean') {
            continue;
        }
        result.push({
            key,
            channelLabel: LABELS[key],
            value: raw,
        });
    }
    return result;
}
